import Vue from "vue/dist/vue.esm.js"
import SelectedConditions from '../components/selectedConditions.vue'

new Vue({
  el: 'selected-conditions',
  components: { SelectedConditions },
})